import React from 'react';
import BaseModel from './BaseModel';
import ReactTimeAgo from 'react-time-ago';
import i18n from '../locales/i18n';
import moment from 'moment';
import { LONG_DISCONNECTED_VISIBILITY_DAYS } from '../containers/Devices/constants';

/** Class representing a generic device. */
class Device extends BaseModel {
    static TYPE_HOST       = 'host';
    static TYPE_PRINTER    = 'printer';
    static TYPE_EFT        = 'eft';
    static TYPE_COLLECTOR  = 'collector';
    static TYPE_CASHDRAWER = 'cashdrawer';

    constructor(properties) {
        super(properties);

        if (this.last_connexion)
            this.last_connexion = moment(this.last_connexion);
    }

    isConnected() {
        return this.status === 'connected';
    }

    wasRecentlyConnected() {
        return moment()
            .subtract(LONG_DISCONNECTED_VISIBILITY_DAYS, 'days')
            .isBefore(this.last_connexion);
    }

    getLastConnectedAt() {
        return (
            <ReactTimeAgo
                date={ this.last_connexion.toDate() }
                locale={ i18n.language }
                timeStyle="round-minute"
            />
        );
    }

    getHostInfos() {
        return {
            _id: this.host_id,
            name: this.host
        };
    }

    getIconName() {
        return 'cube';
    }

    /**
     * Hardware / CUPS make-and-model when reported by PiHyve (options.model).
     *
     * @returns {string}
     */
    deviceModel() {
        const raw = this.options?.model ?? this.device_make_and_model;
        return raw ? String(raw).replace(/\s+/g, ' ').trim() : '';
    }
}

export default Device;
